"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.LanguageContext = exports.ThemeContext = exports.themeClassNameMap = exports.Theme = exports.Language = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const config_provider_1 = __importDefault(require("antd/lib/config-provider"));
const styles_1 = require("@mui/material/styles");
const locale_1 = require("@mui/material/locale");
const fr_CA_1 = __importDefault(require("antd/lib/locale/fr_CA"));
const en_US_1 = __importDefault(require("antd/lib/locale/en_US"));
require("focus-visible");
require("moment/locale/fr-ca");
require("dayjs/locale/fr");
require("dayjs/locale/en");
const MuiTheme_1 = require("./MuiTheme");
const PickersLocalizationProvider_1 = require("./PickersLocalizationProvider");
var Language;
(function (Language) {
    Language["Fr"] = "fr";
    Language["En"] = "en";
})(Language = exports.Language || (exports.Language = {}));
const antdLocales = {
    [Language.Fr]: fr_CA_1.default,
    [Language.En]: en_US_1.default,
};
const muiLocales = {
    [Language.Fr]: locale_1.frFR,
    [Language.En]: locale_1.enUS,
};
var Theme;
(function (Theme) {
    Theme["Default"] = "default";
    Theme["Akinox"] = "akinox";
    Theme["OldSchool"] = "old-school";
    Theme["Msss"] = "msss";
})(Theme = exports.Theme || (exports.Theme = {}));
exports.themeClassNameMap = {
    [Theme.Akinox]: "theme-akinox",
    [Theme.Default]: "theme-default",
    [Theme.OldSchool]: "theme-old-school",
    [Theme.Msss]: "theme-msss",
};
exports.ThemeContext = (0, react_1.createContext)(Theme.Default);
exports.LanguageContext = (0, react_1.createContext)(Language.En);
const ThemeProvider = (_a) => {
    var { children, className, locale = "en", theme = "default", rootFontSize = 16 } = _a, props = __rest(_a, ["children", "className", "locale", "theme", "rootFontSize"]);
    if (!Object.values(Theme).includes(theme)) {
        // eslint-disable-next-line no-console
        console.error(`Theme ${theme} is not supported, falling back to default.`);
        theme = Theme.Default;
    }
    (0, react_1.useEffect)(() => {
        document.documentElement.style.setProperty("--consumer-root-font-size", `${rootFontSize}`);
    }, [rootFontSize]);
    const language = locale.substring(0, 2);
    const classes = (0, classnames_1.default)("gerudo", exports.themeClassNameMap[theme], className);
    return (react_1.default.createElement("div", Object.assign({ className: classes, id: "gerudo" }, props),
        react_1.default.createElement(exports.ThemeContext.Provider, { value: theme },
            react_1.default.createElement(exports.LanguageContext.Provider, { value: language },
                react_1.default.createElement(styles_1.ThemeProvider, { theme: (0, styles_1.createTheme)(MuiTheme_1.themeOptions, muiLocales[language]) },
                    react_1.default.createElement(PickersLocalizationProvider_1.PickersLocalizationProvider, null,
                        react_1.default.createElement(config_provider_1.default, { locale: antdLocales[language] }, children)))))));
};
exports.ThemeProvider = ThemeProvider;
exports.default = exports.ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map